// apps/web/src/pages/Announcements/announcementKind.ts
//
// Metadados visuais por kind de comunicado (label i18n + cores Alamo + ícone),
// compartilhados entre card, detalhe, carrossel de login e banner. Paleta travada
// (alamo-design-system): announcement=azul-protecao, campaign_info=laranja-encanto,
// reminder=âmbar, training=ink. Sem verde-de-marca, sem preto puro.

import { Clock, GraduationCap, Megaphone, Sparkles } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { AnnouncementKind } from '@alamo/types';

export interface AnnouncementKindMeta {
  /** Chave i18n do rótulo (namespace consultor:novidades.kind.*). */
  labelKey: string;
  icon: LucideIcon;
  /** Classes do chip de rótulo (fundo tint + texto/ícone). */
  chipClass: string;
  /** Classe de cor do ícone standalone. */
  iconClass: string;
  /** Gradiente de fallback quando o comunicado não tem capa (faixa 16:9 na cor do kind). */
  coverFallbackClass: string;
}

export const ANNOUNCEMENT_KIND_META: Record<AnnouncementKind, AnnouncementKindMeta> = {
  announcement: {
    labelKey: 'novidades.kind.announcement',
    icon: Megaphone,
    chipClass: 'bg-azul-protecao/10 text-azul-protecao',
    iconClass: 'text-azul-protecao',
    coverFallbackClass: 'from-azul-protecao/15 to-azul-protecao/5 text-azul-protecao/40',
  },
  campaign_info: {
    labelKey: 'novidades.kind.campaign_info',
    icon: Sparkles,
    chipClass: 'bg-laranja-encanto/10 text-laranja-encanto',
    iconClass: 'text-laranja-encanto',
    coverFallbackClass: 'from-laranja-encanto/15 to-laranja-encanto/5 text-laranja-encanto/40',
  },
  reminder: {
    labelKey: 'novidades.kind.reminder',
    icon: Clock,
    chipClass: 'bg-amber-100 text-amber-700',
    iconClass: 'text-amber-600',
    coverFallbackClass: 'from-amber-200/60 to-amber-100/30 text-amber-500/50',
  },
  training: {
    labelKey: 'novidades.kind.training',
    icon: GraduationCap,
    chipClass: 'bg-ink/10 text-ink dark:ring-1 dark:ring-slate-400',
    iconClass: 'text-ink',
    coverFallbackClass: 'from-ink/12 to-ink/4 text-ink/30',
  },
};

export const ANNOUNCEMENT_KINDS: AnnouncementKind[] = [
  'announcement',
  'campaign_info',
  'reminder',
  'training',
];
